// extracted by mini-css-extract-plugin
export default {"tips":"Tips_tips__Bcfzo","penetrate":"Tips_penetrate__w3Mwt"};